import { Box, Button, LoadingWheel, Text } from "@vinomofo/components";

import { Coupon } from "../../contexts/cart/types";
import { CurrencyLabel } from "../currency";

export const CouponSummaryLine = ({
  coupon,
  onRemove,
  loading,
  ...rest
}: {
  coupon: Coupon;
  onRemove?: (code: string) => void;
  loading?: boolean;
}): JSX.Element => {
  return (
    <Box
      width="100%"
      justifyContent="space-between"
      alignItems="start"
      padding={3}
      {...rest}
    >
      <Box mr={3} flex={1} width="100%" pb="6px">
        <Text fontSize={1} color="heading">{`Applied Coupons`}</Text>
      </Box>
      <Box
        display="flex"
        width="100%"
        justifyContent="space-between"
        alignItems="start"
        pb="2px"
      >
        <Box mr={3} flex={1}>
          <Box color="dorianGray" display="flex" alignItems="center">
            <Text fontSize="14px">{coupon.code}</Text>
            <Box mx={1}>{" - "}</Box>
            {onRemove && (
              <Button
                color="deal"
                onClick={() => onRemove(coupon.code)}
                disabled={loading}
              >
                Remove
              </Button>
            )}
          </Box>
          {/* {coupon.name !== coupon.code && (
            <Text color="dorianGray" fontSize="12px" textTransform="capitalize">
              {coupon.name}
            </Text>
          )} */}
        </Box>
        <Box flexGrow={0}>
          {loading ? (
            <LoadingWheel borderWidth="5px" size="2em" />
          ) : (
            <Text
              fontWeight={500}
              color="darkMofo"
              fontSize="14px"
              data-testid="applied-coupon-code-amount"
            >
              <CurrencyLabel amount={-coupon.discounted_amount} />
            </Text>
          )}
        </Box>
      </Box>
    </Box>
  );
};

// export const GiftCardSummaryLine = ({
//   giftCard,
//   onRemove,
//   loading,
// }: {
//   giftCard: GiftCertificate;
//   onRemove: (code: string) => void;
//   loading?: boolean;
// }): JSX.Element => {
//   return (
//     <Box display="flex" justifyContent="space-between" alignItems="flex-start">
//       <Box color="dorianGray" mr={3} flex={1}>
//         <Box display="flex" alignItems="center">
//           <Text fontSize="14px">
//             Gift card (<CurrencyLabel amount={giftCard.balance} />)
//           </Text>
//           <Box mx={1}>{" - "}</Box>
//           <Button color="deal" onClick={() => onRemove(giftCard.code)}>
//             Remove
//           </Button>
//         </Box>
//         <Text fontSize="12px">
//           Gift card balance after use:{" "}
//           <CurrencyLabel amount={giftCard.remaining} />
//         </Text>
//       </Box>
//       <Box flexGrow={0}>
//         {loading ? (
//           <LoadingWheel borderWidth="5px" size="2em" />
//         ) : (
//           <Text fontWeight={500} color="darkMofo" fontSize="14px">
//             <CurrencyLabel amount={-giftCard.used} />
//           </Text>
//         )}
//       </Box>
//     </Box>
//   );
// };
